import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FbAuctionMultipleDetailComponent } from './fb-auction-multiple-detail.component';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FbAuctionModule } from '../fb-auction/fb-auction.module';

@NgModule({
  imports: [
    CommonModule,
    DynamicDialogModule,
    DialogModule,
    ButtonModule,
    CardModule,
    FbAuctionModule
  ],
  declarations: [FbAuctionMultipleDetailComponent],
  exports: [FbAuctionMultipleDetailComponent]
})
export class FbAuctionMultipleDetailModule { }
